import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/** Force English for membership funnel pages (dual / Stripe / portal). */
export function useMembershipFunnelEnglish(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    void i18n.changeLanguage("en");
    document.documentElement.lang = "en";
  }, [i18n]);
}